/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import type { App } from 'vue';

import { vMaska } from 'maska';
import * as Sentry from '@sentry/vue';
import { preloadCaptcha } from '@/composables/useRecaptcha';
import { vuetifyInstance, i18n } from './vuetify';
import pinia from '../store';
import router from '../router';

// VueSweetalert2
import 'sweetalert2/dist/sweetalert2.min.css';

export default function registerPlugins(app: App) {
  Sentry.init({
    app,
    environment: import.meta.env.VITE_NODE_ENV,
    dsn: (import.meta.env.VITE_NODE_ENV === 'development')
      ? '' : 'https://f32816a3c0f348bfb368db5b9d165c4a@o82137.ingest.us.sentry.io/4505075127156736',
    // Lo inyecta vite.config.mts desde SOURCE_VERSION del build de Heroku.
    release: __SENTRY_RELEASE__ || undefined,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    // GPC y GDL son el mismo commit con distinto VITE_APP_NAME y comparten
    // proyecto de Sentry. Sin esta etiqueta no hay forma de saber a que marca
    // pertenece un error salvo leyendo la url evento por evento.
    initialScope: {
      tags: { appName: import.meta.env.VITE_APP_NAME },
    },
    tracesSampleRate: 1.0,
  });

  // Se adelanta la carga del script de captcha: pedir el token en el momento
  // del envio hacia que la descarga coincidiera con la peticion.
  preloadCaptcha();

  app
    .use(pinia)
    .use(router)
    .use(i18n)
    .use(vuetifyInstance)
    .directive('maska', vMaska);
}
